<template>
    <div class="w-100">
        <div class="d-flex ml-3">
            <importador-cotizaciones-modal/>
            <editar-importador-cotizaciones-modal :id="id" :quotationNumber="quotationNumber" />
            <importador-cotizaciones-filtros />
            <Button
                :size="15"
                color="#dc3545"
                colorText="#ffffff"
                tooltip="Recargar Tabla"
                icon="fas fa-filter"
                round
                :width="30"
                class="mt-2 mb-3 ml-2"
                traslate
                @click.native="getQuotationImporters"
            />
        </div>


        <div class="d-flex justify-content-center w-100" style="margin-top: 200px" v-if="dataDataTableQuotationImporterLoading">
            <Loading />
        </div>
        <div v-else class="d-flex p-3">
              
            <div class="w-100 text-center">
                <new-data-table
                    customHeaders
                    :headers="headers"
                    :data="data"
                    :acciones="acciones"
                    :max="10"
                    paginacion
                    buscar
                    numerador
                    idtabla="bookings_embarcados_lista"
                    :seleccionar="obtenerFilaSeleccionada"
                    withSearch
                />
            </div>
            
        </div>


    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { getQuotationImporters , deleteQuotationImporters, generateQuotation, getTariffLineQuotationReport } from '../../../constants/lineas';
import NewDataTable from '../../common/NewDataTable.vue';

import ImportadorCotizacionesModal from '../../modals/lineas/tarifas/importador_cotizaciones/ImportadorCotizacionesModal.vue';
import Loading from '../../common/loading.vue';
import EditarImportadorCotizacionesModal from '../../modals/lineas/tarifas/importador_cotizaciones/EditarImportadorCotizacionesModal';
import ImportadorCotizacionesFiltros from '../../modals/lineas/tarifas/importador_cotizaciones/ImportadorCotizacionesFiltros.vue';
import Button from '../../common/Button.vue';
import { downloadFile } from '../../../mixins';

export default {
    data() {
        return {
            headers: [
                { title: "Cotización", width: "10px" },
                { title: "N° Cotización", width: "30px" },
                { title: "Desde", width: "35px" },
                { title: "Hasta", width: "35px" },
                { title: "Creado Por", width: "35px" },
                { title: "Generado Por", width: "35px" },
                { title: "Descripción", width: "130px" },
                { title: "Acciones", width: "130px" }
            ],
            data : [],
            acciones: [],
            loading : false ,
            id : null ,
            quotationNumber : ""
        };
    },
    props: {},

    components: { 
        ImportadorCotizacionesModal, 
        NewDataTable, 
        Loading, 
        EditarImportadorCotizacionesModal ,
        ImportadorCotizacionesFiltros,
        Button
    },

    created() {},

    mounted() {
        this.getQuotationImporters();
    },

    methods: {
        ...mapActions("lineas", [ 
            'actionSetDataDataTableQuotationImporter', 
            'actionSetDataDataTableQuotationImporterLoading',
            'actionSetShowDataTableQuotationImporterModal'
        ]),
        
        async getQuotationImporters(){

            this.actionSetDataDataTableQuotationImporterLoading( true )  ;

            const { data } = await getQuotationImporters() ;

            this.actionSetDataDataTableQuotationImporter( data ) ;
            
            this.actionSetDataDataTableQuotationImporterLoading( false )  ;
        },
        async generarBotonesAcciones() {
            let me = this;
            me.acciones = [];

            me.data.map( ( val , index ) => {

                me.acciones.push([
                {
                    icon:  "fas fa-check zoom text-success",
                    title: "Generar Tarifas y Recargos"  ,
                    id: index,
                },
                {
                    icon: "fa fa-edit zoom",
                    title:  "Editar" ,
                    id: index,
                },
                {
                    icon: "fas fa-file-excel zoom",
                    title:  "Exportar Cotización a Excel" ,
                    id: index,
                },
                {
                    icon: "fa fa-times text-danger zoom",
                    title: "Eliminar" ,
                    id: index,
                },
                ]);
            });
        },

        async obtenerFilaSeleccionada({ id : item , accion }){
            
            const { id, quotation_number, generate_tariff } = this.data[ item ].data_complementaria ;

            switch ( accion ) {

                case 'Eliminar' : {

                    if( generate_tariff == 1 ) return this.$vToastify.warning('No se puede eliminar, ya que tiene una tarifa creada.', 'Precaución');

                    const response = await this.$vToastify.prompt({ body: `¿Desea eliminar la Cotización N° ${quotation_number}?` });

                    if( ! response ) return ;

                    this.$vToastify.loader("Eliminando Cotización...");

                    try {
                        
                        await deleteQuotationImporters( id ) ;

                        this.$vToastify.stopLoader();

                        this.$vToastify.success("Se ha eliminado cotización correctamente.", 'Éxito');

                        await this.getQuotationImporters();

                    } catch (error) {

                        this.$vToastify.stopLoader();

                        return this.$vToastify.error( "Error al eliminar cotización. Favor, recargar página y volver a intentar." , "Error") ;
                    }
                }
                break ;

                case 'Editar' : 

                    this.id = id ;
                    this.quotationNumber = quotation_number ;
                    this.actionSetShowDataTableQuotationImporterModal( true );

                break ;

                case 'Generar Tarifas y Recargos' : {

                    const response = await this.$vToastify.prompt({ body: `¿Desea Generar Tarifas y Recargos para cotización N° ${quotation_number}?` });

                    if( ! response ) return ;

                    try {

                        this.$vToastify.loader("Generando Tarifas y Recargos...");

                        await generateQuotation( id );

                        this.$vToastify.success("Se han generado Tarifas y Recargos correctamente.", 'Éxito');

                        this.$vToastify.stopLoader() ;

                        await this.getQuotationImporters() ;

                    } catch (error) {

                        this.$vToastify.stopLoader();

                        return this.$vToastify.error( "Error al Tarifas y Recargos. Favor, recargar página y volver a intentar." , "Error") ;
                    }
                }
                break ;

                case  'Exportar Cotización a Excel' : {

                    try {
                        this.$vToastify.loader("Generando Reporte...");
                        
                        const { data } = await getTariffLineQuotationReport( id ) ;
                        
                        this.$vToastify.stopLoader();

                        downloadFile( data , 'tariff_line_quotation.xlsx' ) ;

                    } catch (error) {

                        this.$vToastify.stopLoader();
                        
                        return this.$vToastify.error( "Error al exportar cotización" , "Error") ;
                    };
                    
                }
                break ;
            
                default:
                    break;
            }
        }
    },

    computed: {
        ...mapState("lineas", [
            "dataDataTableQuotationImporter", 
            'dataDataTableQuotationImporterLoading',
            'showDataTableQuotationImporterModal'
        ]),

    },

    watch: {
        dataDataTableQuotationImporter: function (_new) {

            if (_new) {
                
                this.data = _new.map( d => ({
                    data : [ 
                        d.quotation_name ,
                        d.quotation_number ,
                        d.from ,
                        d.to ,
                        d.name_created ,
                        d.name_generated,
                        d.description
                    ],
                    data_complementaria : d
                }));

                this.generarBotonesAcciones();
            }
        },
        showDataTableQuotationImporterModal: function ( _new ){
            
            if( ! _new ) {
                this.id = null ;
                this.quotationNumber = "" ;
            } 
        }
    },

    directives: {},

    filters: {}
};
</script>

<style>

</style>
